// src/app/app.config.ts
import { ApplicationConfig, ENVIRONMENT_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import axios from 'axios';
import { routes } from './app.routes';
import Aura from '@primeuix/themes/aura';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SpinnerComponent } from '@/app/shared/spinner/spinner.component';
import { loadingInterceptor } from '@/app/services/interceptor/loader.interceptor';
import { LoginService } from '@/app/services/login.service';
import { isUnauthorizedSessionError } from '@/app/services/interceptor/session-expiration-error';
import { ToastService } from '@/app/services/script/toast.service';

export const appConfig: ApplicationConfig = {
  providers: [
    SpinnerComponent,
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const loginService = inject(LoginService);
        const toastService = inject(ToastService);

        axios.interceptors.response.use(
          (response) => response,
          (error) => {
            if (isUnauthorizedSessionError(error?.response?.status)) {
              loginService.logoutExpiredSession();
              toastService.suppressFunctionalErrors();
            }

            return Promise.reject(error);
          }
        );
      },
    },
    provideHttpClient(withInterceptors([loadingInterceptor])),
    ToastModule, // 👈 habilita <p-toast>
    MessageService, // 👈 provider global de mensajes
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
      // ✅ Aquí defines la traducción global directamente
      translation: {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar',
        dateFormat: 'dd/mm/yy',
      },
    }),
  ],
};
